import PetsAPI from '@/app/apis/main/pets/pets-api';

export default {
	/**
	 * @param {*} petId
	 */
	async getPetById(petId) {
		return PetsAPI.getPetById(petId);
	},

	/**
	 * @param {*} petDetailsInfo
	 */
	async getPetWeight(petDetailsInfo) {
		return PetsAPI.getPetWeight(petDetailsInfo);
	},
	
	/**
	 * @param {*} petId,
	 * @param {*} petDetails
 	 * */
	async putPetById(petId, petDetails) {
		return PetsAPI.putPetById(petId, petDetails);
	},

	/**
	* @param {*} microchipCode,
	* @param {*} petId
	*/
	async putUpdateMicrochip(microchipCode, petId) {
		return PetsAPI.putUpdateMicrochip(microchipCode, petId);
	},

	/**
	 * @param {*} petId,
	 * @param {*} secondaryImage
 	 * */
	async updateSecondImage(petId, secondaryImage) {
		return PetsAPI.putUpdateSecondaryImage(petId, secondaryImage);
	},

	/**
	 * @param {*} petId
	 * */
	async deletePetById(petId) {
		return PetsAPI.deletePetById(petId);
	},
	
	/**
	 * @param {*} petDetails
	 */
	async postPet(petDetails) {
		return PetsAPI.postPet(petDetails);
	},
	
	/**
	* @params {*} petId
	* */
	async deleteMicrochip(petId) {
		return PetsAPI.deleteMicrochip(petId);
	},

	/**
	 * @param {object} petWeightDetails
	 */
	async addPetWeight(petId, petWeightDetails) {
		return PetsAPI.addPetWeight(petId, petWeightDetails);
	},

	/**
	 * @param {object} petWeightDetails
	 */
	async editPetWeight(petId, petWeightDetails) {
		return PetsAPI.editPetWeight(petId, petWeightDetails);
	},

	/**
	 * @param {object} purchaseDetails
	 */
	async addPetPurchase(purchaseDetails) {
		return PetsAPI.addPetPurchase(purchaseDetails);
	},

	/**
	* @params {Object} purchaseDetails
	* */
	async getPetPurchase(purchaseDetails) {
		return PetsAPI.getPetPurchase(purchaseDetails);
	},

	/**
	* @params petOrderId
	* */
	async deletePetOrder(petOrderId) {
		return PetsAPI.deletePetOrder(petOrderId);
	}
}